export default "__VITE_ASSET__12ab6941__"